import React from 'react';
import { Shield, Target, Calendar } from 'lucide-react';
import { highlights } from '../mock';

const iconMap = {
  1: Shield,
  2: Target,
  3: Calendar
};

const Highlights = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Por que escolher a FEATS?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {highlights.map((highlight) => {
            const Icon = iconMap[highlight.id];
            return (
              <div key={highlight.id} className="bg-gray-800 rounded-2xl p-8 hover:bg-gray-700 transition-colors border border-orange-500/20">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-xl flex items-center justify-center mb-6">
                  <Icon className="h-7 w-7 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  {highlight.title}
                </h3>
                <p className="text-gray-300 leading-relaxed text-lg">
                  {highlight.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Highlights;